import { PremiumFeaturePlaceholder } from '../../components/PremiumFeaturePlaceholder';
import { Eye } from 'lucide-react';

export function ProfileVisibilityBoost() {
  return (
    <PremiumFeaturePlaceholder
      title="Profile Visibility Boost"
      description="Increase your profile visibility by 10x and get discovered by more employers"
      icon={Eye}
      estimatedLaunch="Q1 2026"
      features={[
        'Featured placement in employer search results for 7 days',
        'Priority ranking in match algorithms',
        'Highlighted profile badge showing you\'re actively seeking',
        'Increased visibility in relevant job categories',
        'Real-time analytics showing profile views and engagement',
        'Automatic refresh every 24 hours to stay at the top',
        'Email notifications when employers view your profile',
        'Detailed insights on who\'s interested in your profile',
      ]}
    />
  );
}
